import axios from '../internal/axios';
import { asyncLocalStorage } from '..';
export var signIn = function signIn(_ref) {
  var email = _ref.email,
      password = _ref.password;
  return axios.post("/auth/login", {
    email: email,
    password: password
  }).then(function (response) {
    return response.data;
  }).then(function (result) {
    if (result.success) {
      return result.token;
    } else {
      throw Error(result.status);
    }
  }).then(function (payload) {
    return {
      payload: payload
    };
  }).catch(function (error) {
    var message = error.message;
    return {
      error: message
    };
  });
};
export var signInWithReCapctcha = function signInWithReCapctcha(_ref2) {
  var email = _ref2.email,
      password = _ref2.password,
      recaptcha = _ref2.recaptcha;
  return axios.post("/auth/login", {
    email: email,
    password: password,
    recaptcha: recaptcha
  }).then(function (response) {
    return response.data;
  }).then(function (result) {
    if (result.success) {
      return result.token;
    } else {
      throw Error(result.status);
    }
  }).then(function (payload) {
    return {
      payload: payload
    };
  }).catch(function (error) {
    var message = error.message;
    return {
      error: message
    };
  });
};
export var setToken = function setToken(token) {
  return asyncLocalStorage().setItem('user_session', token);
};